module.exports = __webpack_public_path__ + "img/trebel_artist.25ccbe4.png";